import {call, put, takeEvery} from 'redux-saga/effects';
import Api from '../services/Api';
import {SERVICE_PIT_STOP_TIRES, SERVICE_PIT_STOP_WHEELS} from "../public/journey1/definition/business";
import * as actions from "../actions/createAppointmentActions";
import * as types from "../constants/ActionTypes";
import {FETCH_INTERVENTIONS} from "../constants/ActionTypes";
import Constants from "../services/Constants";
import {ERROR_MESSAGE} from "./notifications";
import Storage from "../services/Storage";

export function* watchFetchCustomerJourneyInformation() {
  yield takeEvery('FETCH.PRE_JOURNEY_INFORMATION.REQUEST', fetchPreJourneyInformation);
  yield takeEvery('FETCH.CUSTOMER_AVAILABILITIES.REQUEST', fetchAvailabilities);
  yield takeEvery('FETCH.TIRES_CHECK_AVAILABILITIES.REQUEST', checkTiresAvailabilities);
  yield takeEvery('SAVE.CUSTOMER_APPOINTMENT.REQUEST', saveAppointmentMaintenanceAndRepair);
  yield takeEvery(types.SAVE_CALL_CENTER_APPOINTMENT, saveCallCenterAppointment);
  yield takeEvery(types.SAVE_CALL_CENTER_MESSAGE_APPOINTMENT, saveCallCenterMessageAppointment);
  yield takeEvery('FETCH.CUSTOMER_HOME_DATA.REQUEST', fetchHomeData);
  yield takeEvery('FETCH.CUSTOMER_DEALER_TIRE_BRAND.REQUEST', fetchDealerTireBrand);
  yield takeEvery('FETCH.CUSTOMER_VEHICLE_CHECK_VIN.REQUEST', checkVinValidity);
}

function* checkVinValidity(action) {
  try {
    const validity = yield call(() => Api.get(`/vin/${action.params.vin}/validate`));
    if (
      action.params.dealer &&
      !action.params.dealer.supportedBrands.includes(validity.body.brand)
    ) {
      yield put({
        type: 'VEHICLE_NOT_SUPPORTED',
      });
    } else {
      validity.body.vin = action.params.vin;
      yield put({
        type: 'FETCH.CUSTOMER_VEHICLE_CHECK_VIN.SUCCESS',
        validatedVin: validity.body,
      });
    }
  } catch (e) {
    yield put({type: 'FETCH.CUSTOMER_VEHICLE_CHECK_VIN.FAILURE'});
  }
}

function* fetchPreJourneyInformation(action) {
  let lastestMileage;
  let leasingCompanies;
  let profile;
  const {vin, dealerId, bookingToken, untrustedVin, callback} = action.params
  try {
    if (vin) {
      lastestMileage = yield call(() => Api.get(`/vehicle/${vin}/mileage`));
    }
  } catch (e) {
  }
  try {
    leasingCompanies = yield call(() => Api.get(`/leasing-companies`));
  } catch (e) {
  }
  try {
    profile = yield call(() => Api.get(`/my/profile`));
  } catch (e) {
  }
  try {
    const connectedUser = Storage.getSessionItem('user')
    const mobility = yield call(() => Api.get(`/d/${dealerId}/mobility`));
    const servicesEndpointUrl = bookingToken ? `/d/${dealerId}/value-services?bookingToken=${bookingToken}` : `/d/${dealerId}/services`;
    const services = yield call(() => Api.get(servicesEndpointUrl));
    let untrustedVinwOffering = null;
    if (untrustedVin) {
      untrustedVinwOffering = yield call(() =>
        Api.get(`/d/${dealerId}/reception/${untrustedVin}`)
      );
    }
    yield put({
      type: 'FETCH.PRE_JOURNEY_INFORMATION.SUCCESS',
      preJourneyInfo: {
        leasingCompanies: leasingCompanies ? leasingCompanies.body : null,
        profile: profile ? profile.body : null,
        mobility: mobility.body,
        services: services.body,
        untrustedVinwOffering: untrustedVinwOffering ? untrustedVinwOffering.body : null,
        lastestMileage: lastestMileage ? lastestMileage.body : null,
        type: action.params.type,
      },
    });

    if (connectedUser) {
      yield put({
        type: "SAVE.GENERAL_INFORMATION",
        params: {
          mileage: lastestMileage ? lastestMileage.body && lastestMileage.body.mileage : null,
          phoneNumber: profile ? profile.body && profile.body.phone : null,
        }
      });
    }
    if (callback) {
      callback();
    }
  } catch (error) {
    yield put({type: 'FETCH.PRE_JOURNEY_INFORMATION.FAILURE', error});
  }
}

function* fetchAvailabilities(action) {
  try {
    const availabilities = yield call(() =>
      Api.post(`/dealers/${action.params.dealerId}/availabilities`, action.params.body)
    );
    yield put({
      type: 'FETCH.CUSTOMER_AVAILABILITIES.SUCCESS',
      availabilities: availabilities.body,
    });
  } catch (e) {
    yield put({type: 'FETCH.CUSTOMER_AVAILABILITIES.FAILURE'});
  }
}

function* checkTiresAvailabilities(action) {
  try {
    let isPitStopTires = false;
    let isPitStopWheels = false;
    const body = {
      services: [SERVICE_PIT_STOP_TIRES],
      waitingAtDealership: false,
      homeService: false,
    };
    const availabilitiesTiresRes = yield call(() =>
      Api.post(`/dealers/${action.params.dealerId}/availabilities`, body)
    );
    if (
      availabilitiesTiresRes &&
      availabilitiesTiresRes.body &&
      availabilitiesTiresRes.body.availabilities &&
      availabilitiesTiresRes.body.availabilities.length > 0 &&
      availabilitiesTiresRes.body.availabilities.filter(
        (availability) => availability.status === 'OPEN'
      ).length > 0
    ) {
      isPitStopTires = true;
    }
    body.services = [SERVICE_PIT_STOP_WHEELS];
    const availabilitiesWheelsRes = yield call(() =>
      Api.post(`/dealers/${action.params.dealerId}/availabilities`, body)
    );
    if (
      availabilitiesWheelsRes &&
      availabilitiesWheelsRes.body &&
      availabilitiesWheelsRes.body.availabilities &&
      availabilitiesWheelsRes.body.availabilities.length > 0 &&
      availabilitiesWheelsRes.body.availabilities.filter(
        (availability) => availability.status === 'OPEN'
      ).length > 0
    ) {
      isPitStopWheels = true;
    }
    yield put({
      type: 'FETCH.TIRES_CHECK_AVAILABILITIES.SUCCESS',
      tiresAvailabilities: {
        isPitStopTires,
        isPitStopWheels,
      },
    });
  } catch (e) {
    yield put({type: 'FETCH.TIRES_CHECK_AVAILABILITIES.FAILURE'});
  }
}

function* saveCallCenterAppointment(action) {
  try {
    const appointment = yield call(() =>
      Api.post(
        `/d/${action.payload.params.dealerId}/vin/${action.payload.params.vin}/journey/appointment/call-center`,
        action.payload.body
      )
    );
    yield put(actions.saveCallCenterAppointmentSuccess({
      appointment: appointment.body,
    }));
    yield put({type: 'SHOW_NOTIFICATION', notification: {message: 'save.success'}});
    yield put({type: types.HIDE_APPOINTMENT_CREATION_MODAL});
    yield put({
      type: FETCH_INTERVENTIONS,
      filters: {
        origins: Constants.ORIGIN_CALL_CENTER.value,
        interventionStatus: ['OPEN', 'OPEN_48', 'APPROVED', 'ONGOING', 'HANDLED', 'READY_FOR_APPOINTMENT', 'NOT_APPROVED', 'FINISHED', 'CANCELLED']
      },
      parameters: {
        page: 0,
        size: 10,
        origins: Constants.ORIGIN_CALL_CENTER.value,
        interventionStatus: ['OPEN', 'OPEN_48', 'APPROVED', 'ONGOING', 'HANDLED', 'READY_FOR_APPOINTMENT', 'NOT_APPROVED', 'FINISHED', 'CANCELLED']
      }
    });
  } catch (error) {
    yield put({type: 'SHOW_NOTIFICATION', notification: {type: ERROR_MESSAGE, message: 'error.generic'}});
    yield put(actions.saveCallCenterAppointmentFailure(error));
  }
}

function* saveCallCenterMessageAppointment(action) {
  try {
    const appointment = yield call(() =>
      Api.post(
        `/d/${action.payload.params.dealerId}/vin/${action.payload.params.vin}/journey/message`,
        action.payload.body
      )
    );
    yield put(actions.saveCallCenterMessageAppointmentSuccess({
      appointment: appointment.body,
    }));
    yield put({type: 'SHOW_NOTIFICATION', notification: {message: 'save.success'}});
    yield put({type: types.HIDE_MESSAGE_APPOINTMENT_CREATION_MODAL});
    yield put({
      type: 'FETCH_INTERVENTIONS.REQUEST',
      filters: {
        origins: Constants.ORIGIN_CALL_CENTER.value,
        interventionStatus: ['OPEN', 'OPEN_48', 'APPROVED', 'ONGOING', 'HANDLED', 'READY_FOR_APPOINTMENT', 'NOT_APPROVED', 'FINISHED', 'CANCELLED']
      },
      parameters: {
        page: 0,
        size: 10,
        origins: Constants.ORIGIN_CALL_CENTER.value,
        interventionStatus: ['OPEN', 'OPEN_48', 'APPROVED', 'ONGOING', 'HANDLED', 'READY_FOR_APPOINTMENT', 'NOT_APPROVED', 'FINISHED', 'CANCELLED']
      }
    });
  } catch (error) {
    yield put({type: 'SHOW_NOTIFICATION', notification: {type: ERROR_MESSAGE, message: 'error.generic'}});
    yield put(actions.saveCallCenterMessageAppointmentFailure(error));
  }
}

function* saveAppointmentMaintenanceAndRepair(action) {
  let idData;
  let comment;
  try {
    const appointment = yield call(() =>
      Api.post(
        `/d/${action.params.dealerId}/vin/${action.params.vin}/journey/${
          action.params.type
        }`,
        action.params.body.body
      )
    );
    if (action.params.comment) {
      comment = yield call(() => Api.post(`/my/comment`, action.params.comment));
    }
    yield put({
      type: 'SAVE.CUSTOMER_APPOINTMENT.SUCCESS',
      appointment: appointment.body,
      idData: idData && idData.body ? idData.body : null,
      comment: comment && comment.body ? comment.body : null,
    });
    if (action.params.callback) {
      action.params.callback();
    }
  } catch (error) {
    yield put({type: 'SAVE.CUSTOMER_APPOINTMENT.FAILURE', error});
  }
}

function* fetchDealerTireBrand(action) {
  try {
    const response = yield call(() => Api.get(`/d/${action.params.dealerId}/tires`));
    yield put({
      type: 'FETCH.CUSTOMER_DEALER_TIRE_BRAND.SUCCESS',
      response
    });
  } catch (e) {
    yield put({type: 'FETCH.CUSTOMER_DEALER_TIRE_BRAND.FAILURE'});
  }
}

function* fetchHomeData(action) {
  const params = action.params;
  let appointment;
  let dealer;
  let idData;
  let vehicles;
  let vehicle;
  let dealers;
  try {
    appointment = yield call(() => Api.get(`/my/appointment`));
  } catch (e) {
    appointment = null;
  }
  if (appointment) {
    try {
      dealer = yield call(() =>
        Api.get(`/my/dealer?dealerId=${appointment.body.dealer}`)
      );
    } catch (e) {
      yield put({type: 'FETCH.CUSTOMER_HOME_DATA.FAILURE'});
    }
    try {
      vehicles = yield call(() => Api.get(`/my/vehicle`));
      if (
        vehicles &&
        vehicles.body &&
        Array.isArray(vehicles.body) &&
        vehicles.body.find(v => v.vin === appointment.body.vin)
      ) {
        vehicle = vehicles.body.find(v => v.vin === appointment.body.vin);
      }
    } catch (e) {
    }
    const response = {
      body: {
        dealer: dealer && dealer.body ? dealer.body : null,
        vehicle,
        vehicles: vehicles && vehicles.body ? vehicles.body : null,
        appointment: appointment && appointment.body ? appointment.body : null,
        idData: idData && idData.body ? idData.body : null,
      },
    }
    yield put({type: 'FETCH.CUSTOMER_HOME_DATA.SUCCESS', response});
  } else {
    try {
      dealers = yield call(() => Api.get(`/dealers`, params));
      if (dealers.body && dealers.body.length === 1) {
        yield put({type: "SAVE.SELECTED_DEALER", selectedDealer: dealers.body[0]});
      }
    } catch (error) {
      yield put({type: "FETCH.CUSTOMER_HOME_DATA.FAILURE", error});
    }
    try {
      vehicles = yield call(() => Api.get(`/my/vehicle`, params));
      if (vehicles.body && vehicles.body.length === 1) {
        //yield put({type:"SET_SELECTED_VIN", selectedVIN: vehicles.body[0].vin});
        yield put({type: "SET_SELECTED_VEHICLE", selectedVehicle: vehicles.body[0]});
        yield put({
          type: "SAVE.GENERAL_INFORMATION",
          params: {
            plateNumber: vehicles.body[0].licensePlate,
          }
        });

      }
    } catch (error) {
      yield put({type: "FETCH.CUSTOMER_HOME_DATA.FAILURE", error});
    }
    const response = {
      body: {
        dealers: dealers && dealers.body ? dealers.body : null,
        vehicles: vehicles && vehicles.body ? vehicles.body : null,
        appointment,
      }
    };
    yield put({
      type: 'FETCH.CUSTOMER_HOME_DATA.SUCCESS', response
    });
  }
}
